import React, { useCallback, useMemo } from 'react';
import { BetType } from '../../enums/tableNumbers';
import ChipOnTable from '../chip/chip-on-table';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { doChipStore } from '../../store/doChipStore';
import { marketType } from '../../enums/marketType';
import { parseNumberByPrecision } from '@pascal/pascal-core';
import { mathConfig, mathJS } from '../../helpers/mathFormat';
import { freeBetStore } from '@pascal/pascal-core/shared/core/store';

const OvalCenterCombinations = observer(({ handleDoChip }) => {
  const { getAllBetsModels: allBetsModels } = doChipStore;
  const { activeFreeBet } = freeBetStore;

  const handleGetColumnChip = useCallback((marketType, betType) => {
    const combinationAndChip = allBetsModels.length
      ? allBetsModels[0]?.betModel
      : [];
    const columnChip = combinationAndChip?.find((combinations) => combinations.bet.type === marketType);
    return {
      [betType]: columnChip?.includedBets ? columnChip?.includedBets?.reduce((acc, cur) => {
        acc = parseNumberByPrecision(1,
          +mathJS.format(acc + (cur.hasOwnProperty('winAmount') ? cur.winAmount ? cur.winAmount : 0 : cur.amount),
            mathConfig),
        );
        return acc;
      }, 0) : columnChip?.bet.amount,
    };
  }, [allBetsModels]);

  const memoAllChipsTypes = useMemo(() => {
    if (allBetsModels.length) {
      return allBetsModels[0]?.betModel.map(
        (item) => item.bet.type,
      );
    }
    return [allBetsModels];
  }, [allBetsModels]);

  const tiersColumnChip = handleGetColumnChip(marketType.Tiers, BetType.Tiers);
  const orphelinsColumnChip = handleGetColumnChip(marketType.Orphelins, BetType.Orphelins);
  const voisinsColumnChip = handleGetColumnChip(marketType.Voisins, BetType.Voisins);
  const zeroColumnChip = handleGetColumnChip(marketType.Zero, BetType.Zero);

  return (
    <div className={`mid-main-game-center-wrp ${activeFreeBet.id ? 'disabled' : ''}`}>
      <div className="tier-cont" data={BetType.Tiers} onClick={handleDoChip}>
        <ChipOnTable
          type={BetType.Tiers}
          modelType={marketType.Tiers}
          columnChips={tiersColumnChip}
          child={() => <p className="mid-game-center-text" data={BetType.Tiers}>Tier</p>}
          allChipsTypes={memoAllChipsTypes}
        />
        <span className="ov-block-span"/>
      </div>
      <div className="orphelins-cont" data={BetType.Orphelins} onClick={handleDoChip}>
        <ChipOnTable
          type={BetType.Orphelins}
          modelType={marketType.Orphelins}
          columnChips={orphelinsColumnChip}
          child={() => <p className="mid-game-center-text" data={BetType.Orphelins}>orphelins</p>}
          allChipsTypes={memoAllChipsTypes}
        />
        <span className="ov-block-span"/>
      </div>
      <div className="voisins-cont" data={BetType.Voisins} onClick={handleDoChip}>
        <ChipOnTable
          type={BetType.Voisins}
          modelType={marketType.Voisins}
          columnChips={voisinsColumnChip}
          child={() => <p className="mid-game-center-text" data={BetType.Voisins}>voisins</p>}
          allChipsTypes={memoAllChipsTypes}
        />
      </div>
      <div className="zero-cont" data={BetType.Zero} onClick={handleDoChip}>
        <ChipOnTable
          type={BetType.Zero}
          modelType={marketType.Zero}
          columnChips={zeroColumnChip}
          child={() => <p className="mid-game-center-text" data={BetType.Zero}>zero</p>}
          allChipsTypes={memoAllChipsTypes}
        />
      </div>
    </div>
  );
});

export default OvalCenterCombinations;
